"use strict";
/*
 *  Copyright (C) 2020  Attila Aldemir <a_aldemir@hotmail.de>
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU Affero General Public License as published
 *  by the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU Affero General Public License for more details.
 *
 *  You should have received a copy of the GNU Affero General Public License
 *  along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ClaimController_1 = __importDefault(require("./controllers/ClaimController"));
var ClaimService_1 = __importDefault(require("./services/ClaimService"));
var ClaimHandler = /** @class */ (function () {
    function ClaimHandler() {
        this.claimController = new ClaimController_1.default(new ClaimService_1.default());
    }
    ClaimHandler.prototype.prepareUserData = function (params) {
        return this.claimController.prepareUserData(params);
    };
    ClaimHandler.prototype.setUserData = function (params) {
        this.claimController.setUserData(params);
    };
    ClaimHandler.prototype.createHashes = function () {
        return this.claimController.createHashes();
    };
    ClaimHandler.prototype.createClaim = function (params) {
        return this.claimController.createClaim(params);
    };
    ClaimHandler.prototype.verifyClaim = function (params) {
        return this.claimController.verifyClaim(params);
    };
    return ClaimHandler;
}());
exports.default = ClaimHandler;
